import React, { memo, forwardRef } from "react";
const SvgSuperscript = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <rect
        width={11}
        height={19}
        x={5.5}
        y={8.5}
        stroke="#717171"
        strokeDasharray="2 2"
        strokeLinejoin="round"
        rx={1.5}
      />
      <rect width={9} height={11} x={19} y={5} fill="#DBDBDB" rx={2} />
    </svg>
  );
});
SvgSuperscript.displayName = "SvgSuperscript";
const MemoForwardRef = memo(SvgSuperscript);
export default MemoForwardRef;
